/**
 * 搜尋列前面的標：已有圈檔用曾調閱門標，門牌改社區用聚落標，其餘社區用針標。
 */
export function autocompleteSuggestionView(item) {
    const label = item?.display || item?.name || item?.display_name || '未命名';
    const door = item?.kind === 'doorplate';
    const fetched = !!item?.previouslyFetched;
    const promoted = !!item?.promotedFromDoorplate;
    const mark = door || fetched ? '🚪' : (promoted ? '🏘️' : '📍');
    const meta = door || fetched
        ? (item?.meta || '曾調閱')
        : (item?.meta || (promoted ? '社區門牌命中' : '社區'));
    return { label, mark, main: `${mark} ${label}`, meta };
}
